//type NotificationType =  'NEW_ORDER' | 'ORDER_CANCELLED' | 'ORDER_CANCELLED' |  'PRODUCT_OUT_OF_STOCK' ;
export enum NotificationType {
    // enum values here
    'NEW_ORDER' = "NEW_ORDER",
    'ORDER_CANCELLED' = "ORDER_CANCELLED",
    'PRODUCT_OUT_OF_STOCK' = "PRODUCT_OUT_OF_STOCK",
    'NEW_CLIENT' = "NEW_CLIENT"
}
